export function setLastCmd(a, b, cmdHistory) {
    cmdHistory.a = a;
    cmdHistory.b = b;
}
//# sourceMappingURL=setLastCmd.js.map